function validateHexInput(hex) {
    if (!hex.match(/^#([a-f0-9]{3,4}|[a-f0-9]{6}|[a-f0-9]{8})$/i)) {
        throw new Error("Invalid hex input, must be a 3, 4, 6 or 8 character long hexadecimal number preceded with a #");
    }
}
/**
 * Helper that converts any hex to a 6 digit version. For a 8 digit hex, the last 2 characters present the alpha-channel in an hexadecimal format.
 * The 4 digit-version is a shorter version for the 8 digit one. 3 digits are the shorter versions for the regular 6 digit hex, so without an alpha channel.
 */
export function to6DigitHex(hex) {
    const hexValue = hex.replace("#", "");
    if (hexValue.length === 3 || hexValue.length === 4) {
        return hexValue.replace(/([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])/, "$1$1$2$2$3$3").substring(0, 6);
    }
    if (hexValue.length === 8) {
        return hexValue.substring(0, 6);
    }
    return hexValue;
}
/**
 * Gets the alpha value from an hex. As this only works for 8 or 4 digit hexes, it returns the full 255 when it isn't one of those 2 lengths.
 */
export function getAlphaFromHexColor(hex) {
    const hexValue = hex.replace("#", "");
    if (hexValue.length === 4) {
        return parseInt(hexValue.substring(3, 5), 16);
    }
    if (hexValue.length === 8) {
        return parseInt(hexValue.substring(6, 9), 16);
    }
    return 255;
}
export function convertHexColorToRGB(hex) {
    validateHexInput(hex);
    const hexValue = to6DigitHex(hex);
    return {
        r: parseInt(hexValue[0] + hexValue[hexValue[3] ? 1 : 0], 16),
        g: parseInt(hexValue[hexValue[3] ? 2 : 1] + (hexValue[3] || hexValue[1]), 16),
        b: parseInt((hexValue[4] || hexValue[2]) + (hexValue[5] || hexValue[2]), 16),
    };
}
export function convertHexColorToRGBA(hex) {
    const { r, g, b } = convertHexColorToRGB(hex);
    const a = getAlphaFromHexColor(hex);
    return { r, g, b, a };
}
//# sourceMappingURL=hex2rgb.js.map